export default __webpack_public_path__ + "static/media/anpc-sal.d76e1c07.png";